export default __webpack_public_path__ + "static/media/Final-Monitoring-Agency-Report.57b384fb.pdf";